import PropTypes from 'prop-types';
import Layout from 'layouts/Default';
import { Section } from 'elements/Containers';
import PostCard from 'components/PostCard';
import Pagination from 'components/Pagination';
import BlogCta from 'components/BlogCta';
import Yoast from 'components/Yoast';
import { Caption, Heading2 } from 'elements/Typography';

import { getPaginatedPostsByCategory, getPostCountByCategory } from 'lib/api';
import Canonical from 'components/Canonical';

const PaginatedPage = ({
  posts: { edges },
  category,
  data: { pages },
  currentPage,
  slug,
}) => (
  <Layout>
    <Canonical />
    <Yoast seo={category.seo} />
    <Section>
      <div className="text-center md:mx-auto md:max-w-2xl">
        <Caption as="p">Archive</Caption>
        <Heading2 as="p" className="text-grey-10">
          {category.name}
        </Heading2>
      </div>
      <div className="mx-auto mt-12 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3">
        {edges.map(({ node }, index) => (
          <PostCard
            key={node.id}
            id={node.id}
            slug={node.slug}
            featuredImage={node.featuredImage}
            categories={node.categories}
            title={node.title}
            author={node.author}
            date={node.date}
            priority={index <= 2}
          />
        ))}
      </div>
      <Pagination
        title={category.seo.title}
        currentPage={currentPage}
        totalPages={pages}
        base={`/category/${slug}`}
      />
      <BlogCta />
    </Section>
  </Layout>
);

PaginatedPage.propTypes = {
  posts: PropTypes.shape([]).isRequired,
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
    seo: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  data: PropTypes.shape({
    pages: PropTypes.number.isRequired,
  }).isRequired,
  currentPage: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
};

export const getStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps = async ({ params }) => {
  const { posts, category } = await getPaginatedPostsByCategory(
    params.slug,
    params.page,
  );
  const data = await getPostCountByCategory(params.slug);

  if (posts.edges.length === 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      posts,
      category,
      currentPage: parseInt(params.page, 10),
      data,
      slug: params.slug,
    },
    revalidate: 900,
  };
};

export default PaginatedPage;
